import React from 'react';

const DigitalEngineeringTools = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Solving for Today, Scaling for Tomorrow</h1>

      <p>
        The best tools solve real problems. Products that are genuinely useful don’t need much explaining — they’re shaped by what people actually do. Start embarrassingly simple. Build something a small team can’t live without. Listen closely. Real utility drives adoption.
      </p>

      <h2>NSW Digital Engineering – Sign & Chainage Generator</h2>
      <p>
        Trialled on the <strong>Mount Ousley Interchange</strong>, this tool automatically generated signs and chainages based on key parameters.
      </p>
      <ul>
        <li>Targeted small modelling issues to improve handover of enhanced models to engineering teams.</li>
        <li>Generated 3D labels along chainages, with parameter-driven orientation.</li>
        <li>A parametric sign generator that converted PNGs into FBX assets with footings — enabling teams to produce custom signage in seconds for traffic staging and digital twins.</li>
      </ul>

      <h2>MRPA – BIM File Validator</h2>
      <p>
        Built for the <strong>Metropolitan Roads Program Alliance</strong>, this validator caught common BIM issues before models were issued for review. It enforced key requirements and gave instant feedback to designers.
      </p>
      <ul>
        <li>Checked naming conventions, metadata, spatial alignment, and more.</li>
        <li>Cloud-based and drag-and-drop simple — outputting HTML dashboards and a detailed CSV for every object.</li>
        <li>Freed up BIM coordinators to focus on higher-value work.</li>
      </ul>

      <h2>Takeoff Tools</h2>
      <p>
        Used by teams across the country, this became a <strong>Swiss Army knife</strong> for extracting quantities and visualising data from CAD files.
      </p>
      <ul>
        <li>Provided complete takeoff summaries from model files (i.e. lengths, volumes, counts by layer, etc.).</li>
        <li>Cloud-based takeoffs with visualization using Python, FME, JavaScript and Leaflet to render interactive maps with queryable metadata.</li>
        <li>Saved hundreds of hours otherwise spent manually counting from PDFs.</li>
      </ul>

      <h2>Why It Worked</h2>
      <p>
        Start with pain points. Then build sharp, targeted tools to solve them. This isn’t innovation for its own sake — it's practical, repeatable, and scales naturally across teams and projects.
      </p>
    </main>
  );
};

export default DigitalEngineeringTools;
